import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import { StoreState } from '../../../reducers';
import { Form, DocumentsBlock, SharePanelContainer, FormHeader, FormBody, FormBodyInner, SwitchLabel, ButtonCancel, ButtonSend, Loader } from './styles';
import { FormField } from './typings';
import Accordion from '../../Accordion';
import { FormState } from '../../../containers/Share/reducer';
import { shareItems, setCrmContacts, SharePanelActionKeys, finishShare } from '../../../containers/Share/actions';
import SharedDocuments from '../../../containers/Share/SharedDocuments';
import HeaderBlock from '../../HeaderBlock';
import UprezShareFormField from '../../../containers/Share/UprezForm/Field';
import Switch from '../../Form/Switch';
import Utils from '../../../utils';
import ApiUtils from '../../../utils/api';

interface UprezShareFormProps {
	form: FormState;
	isOpen: boolean;
	isProcessing: boolean;
	isCreateDealAvailable: boolean;
	actionButtonColor: string;
	dispatch: Dispatch<StoreState>;
}

const headerFields = [
	FormField.Email,
	FormField.Subject,
	FormField.Message
];

const contactFields = [
	FormField.Firstname,
	FormField.Surname,
	FormField.Company,
	FormField.Email,
	FormField.Phone,
	FormField.Position
];

const UprezShareForm = ({
	form,
	isOpen,
	isProcessing,
	isCreateDealAvailable,
	actionButtonColor,
	dispatch,
}: UprezShareFormProps) => {

	React.useEffect(() => {
		if (isOpen) {
			ApiUtils.getCrmAccounts()
				.then((crmContacts) => dispatch(setCrmContacts(crmContacts)))
				.catch(() => dispatch(setCrmContacts([])));
		}
	}, [isOpen]);

	const handleSendForm = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		dispatch(shareItems());
	};

	const renderFields = (fields: FormField[], isHeader: boolean) =>
		fields.map((field, index) => (
			<UprezShareFormField
				key={`${name}${index}`}
				fieldName={field}
				isHeader={isHeader}
			/>
		))
	;

	const handleCreateDealChange = () => {
		const { createDeal } = form;
		dispatch({
			type: SharePanelActionKeys.SET_FORM_FIELD,
			name: FormField.CreateDeal,
			value: !createDeal,
		});
	};

	const { contactEmail, createDeal } = form;
	const hasMultipleContacts = contactEmail.includes(',');

	return (
		<SharePanelContainer isOpen={isOpen}>
			{isProcessing &&
				<Loader>
					{Utils.getSvgIcon('iconset_loading')}
					<Translate value="messages.loading" />
				</Loader>
			}
			<Form onSubmit={handleSendForm}>
				<FormHeader>
					<ButtonCancel
						type="button"
						onClick={() => dispatch(finishShare())}
						color={actionButtonColor}
					>
						<Translate value="messages.cancel" />
					</ButtonCancel>
					{isCreateDealAvailable &&
						<Switch
							name="createDeal"
							isActive={createDeal}
							activeColor={actionButtonColor}
							onChange={handleCreateDealChange}
							label={(
								<SwitchLabel
									value="messages.create_deal_in_crm"
									dangerousHTML={true}
								/>
							)}
						/>
					}
					<ButtonSend
						type="submit"
						disabled={isProcessing}
						color={actionButtonColor}
					>
						<Translate value="messages.send" />
					</ButtonSend>
				</FormHeader>
				<FormBody>
					<FormBodyInner>
						{renderFields(headerFields, true)}
						{!hasMultipleContacts &&
							<Accordion
								title={`share.${FormField.Contact}`}
								isOpened={false}
							>
								{renderFields(contactFields, false)}
							</Accordion>
						}
						<DocumentsBlock>
							<HeaderBlock title={`share.${FormField.Documents}`} />
							<SharedDocuments />
						</DocumentsBlock>
					</FormBodyInner>
				</FormBody>
			</Form>
		</SharePanelContainer>
	);
};

export default UprezShareForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/UprezForm/index.tsx